"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _core = require("@widget-editor/core");

var _formLabel = _interopRequireDefault(require("../../styles-common/form-label"));

var _inputGroup = _interopRequireDefault(require("../../styles-common/input-group"));

var _style = require("./style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var EndUserFilters = function EndUserFilters(_ref) {
  var serializedFields = _ref.fields,
      endUserFilters = _ref.endUserFilters,
      setEndUserFilters = _ref.setEndUserFilters,
      patchConfiguration = _ref.patchConfiguration;
  var fields = (0, _react.useMemo)(function () {
    return serializedFields.map(function (field) {
      var _constants$ALLOWED_FI, _constants$ALLOWED_FI2;

      return {
        label: field.metadata && field.metadata.alias ? field.metadata.alias : field.columnName,
        value: field.columnName,
        type: (_constants$ALLOWED_FI = (_constants$ALLOWED_FI2 = _core.constants.ALLOWED_FIELD_TYPES.find(function (type) {
          return type.name === field.type;
        })) === null || _constants$ALLOWED_FI2 === void 0 ? void 0 : _constants$ALLOWED_FI2.type) !== null && _constants$ALLOWED_FI !== void 0 ? _constants$ALLOWED_FI : 'string'
      };
    }).sort(function (option1, option2) {
      return option1.label.localeCompare(option2.label);
    });
  }, [serializedFields]);
  var value = (0, _react.useMemo)(function () {
    return endUserFilters.map(function (str) {
      return {
        label: str,
        value: str
      };
    });
  }, [endUserFilters]);
  var onChangeColumns = (0, _react.useCallback)(function (options) {
    setEndUserFilters((options !== null && options !== void 0 ? options : []).map(function (_ref2) {
      var value = _ref2.value;
      return value;
    }));
    patchConfiguration();
  }, [patchConfiguration, setEndUserFilters]);
  return _react["default"].createElement("div", null, _react["default"].createElement(_style.InfoCallout, null, "End-user filters are filters that are embedded in the visualization and thus filters that the end-user can interact with outside of the widget editor."), _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
    htmlFor: "end-user-filter-columns"
  }, "Columns with filter"), _react["default"].createElement(_reactSelect["default"], {
    isMulti: true,
    id: "end-user-filter-columns",
    name: "end-user-filter-columns",
    placeholder: "Select columns",
    value: value,
    options: fields,
    onChange: onChangeColumns
  })));
};

EndUserFilters.propTypes = {
  fields: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  endUserFilters: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  setEndUserFilters: _propTypes["default"].func.isRequired,
  patchConfiguration: _propTypes["default"].func.isRequired
};
var _default = EndUserFilters;
exports["default"] = _default;